export const CREATE_LOADING_NOTIFICATION = 'CREATE_LOADING_NOTIFICATION';
export const CREATE_SUCCESS_NOTIFICATION = 'CREATE_SUCCESS_NOTIFICATION';
export const CREATE_ERROR_NOTIFICATION = 'CREATE_ERROR_NOTIFICATION';
export const ACKNOWLEDGE_NOTIFICATION = 'ACKNOWLEDGE_NOTIFICATION';
export const ACKNOWLEDGE_NOTIFICATIONS = 'ACKNOWLEDGE_NOTIFICATIONS';
